export default {
    betData(state) {
        return state.betData;
    },
    rates(state) {
        return state.rates;
    },
};
